import { AssignmentEmployeeModule } from './core/components/assignment-employee/assignment-employee.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { GuestFormComponent } from './core/components/guest-form/guest-form.component';
import { AuthGuard } from './core/components/guards/auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '',
                loadChildren: () => import('./core/components/auth/login/login.module').then(m => m.LoginModule)
            },
            {
                path: '',
                component: AppLayoutComponent,
                children: [
                    {
                        path: 'assignment-employee',
                        loadChildren: () =>
                            import('./core/components/assignment-employee/assignment-employee.module')
                                .then(m => m.AssignmentEmployeeModule),
                        canActivate: [AuthGuard]
                    },

                    {
                        path: 'guest-form',
                        component: GuestFormComponent,
                        canActivate: [AuthGuard]
                    }

                ]
            },
            {
                path: 'auth',
                loadChildren: () => import('./core/components/auth/auth.module').then(m => m.AuthModule),
            },
            {
                path: '**',
                redirectTo: '/auth/notfound'
            },
        ], {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload'
        })
    ],

    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
